// removed by extract-text-webpack-plugin
module.exports = {"button":"button-module_button_2k5pG","fixedWidth":"button-module_fixedWidth_1tpxb","primary":"button-module_primary_3ViUq","large":"button-module_large_2kt2y"};


//////////////////
// WEBPACK FOOTER
// ./client/components/button/button.module.css
// module id = 458
// module chunks = 1 3